import React from 'react';
import { ClockIcon } from 'lucide-react';
import { useCountdown } from '../hooks/useCountdown';
export function AnnouncementBar() {
  const {
    hours,
    minutes,
    seconds
  } = useCountdown();
  return <aside className="sticky top-0 z-50 flex h-9 w-full items-center justify-center gap-2 bg-brand-ocean px-3 text-white shadow-sm" data-id="element-18" data-mp="jtk116wp6chf">
      <p className="truncate text-[10px] font-extrabold tracking-[0.08em] sm:text-[11px]" data-id="element-19" data-mp="euh9mp9n44rx">
        🌍 Offerta valida per oggi · GEOGRAFIA PRONTA™ a 19 €
      </p>
      <span className="flex items-center gap-1 rounded-full bg-white/15 px-2 py-0.5 text-[10px] font-extrabold tabular-nums sm:text-[11px]" data-id="element-20" data-mp="5tst9nwrxsbv">
        <ClockIcon className="h-3 w-3" aria-hidden="true" data-id="element-21" data-mp="vr90znm3myt" />
        <span aria-label={`Offerta in scadenza tra ${hours} ore, ${minutes} minuti e ${seconds} secondi`} data-id="element-22" data-mp="3s22a2vsmgnq5">
          {hours}:{minutes}:{seconds}
        </span>
      </span>
    </aside>;
}